import request from '../request';
export const previewDataByField = (params) => {
    return request({
        url: '/prod-api/dataease/datasetTree/previewDataByField',
        method: 'post',
        body: params
    });
};
export const getInfo = () => {
    return request({
        url: `/prod-api/system/user/getInfo`,
        method: 'get'
    });
};
export const fetchReport = (id) => {
    return request({
        url: `/prod-api/consumer/report/${id}`,
        method: 'get'
    });
};
